import api from "./api";
import config from "../config";

export default {
  fetchBalance(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `financials/balance`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchBalanceTransactions(apiKey, { startingAfter, endingBefore, accountId }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `financials/balance_transactions`,
          json: {
            starting_after: startingAfter,
            ending_before: endingBefore,
            account_id: accountId
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/BalanceUtil.js